import React, { useState } from 'react';
import { signInWithGoogle } from '../firebase';
import './Login.css';

function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      await signInWithGoogle();
    } catch (error) {
      setError('Failed to sign in. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src="/logo.png" alt="StayCombinator" className="logo" />
        <h1>StayCombinator</h1>
        <p className="tagline">Verified Stays, Zero Fees</p>

        <button onClick={handleGoogleLogin} disabled={loading} className="google-btn">
          {loading ? 'Signing in...' : 'Sign in with Google'}
        </button>

        {error && <p className="error">{error}</p>}

        <p className="info">
          Sign in with your Google account to list or browse properties.
        </p>
      </div>
    </div>
  );
}

export default Login;
